export function PageHead({ eyebrow, title, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-8 fade-up">
      <div>
        <p className="label mb-1">{eyebrow}</p>
        <h1 className="font-head font-black text-3xl sm:text-4xl tracking-tighter">{title}</h1>
      </div>
      {children}
    </div>
  );
}

export function Badge({ status, children }) {
  const map = {
    completed: "bg-[#00A86B]/10 text-[#00A86B] border-[#00A86B]/30",
    Paid: "bg-[#00A86B]/10 text-[#00A86B] border-[#00A86B]/30",
    Resolved: "bg-[#00A86B]/10 text-[#00A86B] border-[#00A86B]/30",
    upcoming: "bg-[#B8860B]/10 text-[#8a6d00] border-[#FFD700]",
    Outstanding: "bg-[#B8860B]/10 text-[#8a6d00] border-[#FFD700]",
    overdue: "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/30",
    Open: "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/30",
    default: "bg-black/5 text-[#555] border-black/15",
  };
  const cls = map[status] || map.default;
  return <span className={`text-xs px-2 py-0.5 rounded-sm border font-semibold ${cls}`}>{children || status}</span>;
}

export function Progress({ value }) {
  const color = value >= 100 ? "#00A86B" : value >= 60 ? "#002FA7" : "#FFD700";
  return (
    <div className="w-full h-2 bg-black/10">
      <div style={{ width: `${value}%`, background: color }} className="h-full transition-all duration-500" />
    </div>
  );
}
